import { IProject } from "../interfaces/project.interface";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface ProjectsState {
    projects: IProject[];
    currentProject: IProject | null;
}

const initialState: ProjectsState = {
    projects: [],
    currentProject: null,
};

export const projectsSlice = createSlice({
    name: "projects",
    initialState,
    reducers: {
        clear: (state) => {
            state.projects = [];
        },
        fetched: (state, action: PayloadAction<IProject[]>) => {
            state.projects = action.payload;
        },
        selected: (state, action: PayloadAction<IProject>) => {
            state.currentProject = action.payload;
        },
    },
});

export const { clear, fetched, selected } = projectsSlice.actions;

export const selectProjects = (state: RootState) => state.projects;

export default projectsSlice.reducer;
